module.exports = __webpack_public_path__ + "img/contents_delivery@2x.1c468320.png";